import { render } from "./ProjectWarehouseSection.vue?vue&type=template&id=4dec4771&scoped=true&ts=true"
import script from "./ProjectWarehouseSection.vue?vue&type=script&lang=ts"
export * from "./ProjectWarehouseSection.vue?vue&type=script&lang=ts"

import "./ProjectWarehouseSection.vue?vue&type=style&index=0&id=4dec4771&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dec4771"]])

export default __exports__